import React, { useState } from 'react';
import { Star } from 'lucide-react';

/**
 * Valutazione a stelle. Interattiva se viene passato `onChange`, altrimenti sola lettura.
 * @param {number} value        valore corrente (0..max)
 * @param {(v:number)=>void} onChange  se presente, abilita la selezione
 * @param {number} max          numero di stelle (default 5)
 * @param {'sm'|'md'|'lg'} size dimensione
 * @param {boolean} showValue   mostra il valore numerico accanto alle stelle
 */
export function StarRating({ value = 0, onChange, max = 5, size = 'md', showValue = false, className = '', testId }) {
  const [hover, setHover] = useState(0);
  const interactive = typeof onChange === 'function';
  const px = size === 'lg' ? 'h-7 w-7' : size === 'sm' ? 'h-3.5 w-3.5' : 'h-5 w-5';
  const shown = hover || value;

  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid={testId} role={interactive ? 'radiogroup' : 'img'} aria-label={`Valutazione ${Math.round(value * 10) / 10} su ${max}`}>
      {Array.from({ length: max }).map((_, i) => {
        const idx = i + 1;
        const filled = idx <= shown;
        const StarEl = (
          <Star
            className={`${px} transition-colors ${filled ? 'fill-amber-400 text-amber-400' : 'fill-transparent text-muted-foreground/40'}`}
          />
        );
        if (!interactive) return <span key={idx}>{StarEl}</span>;
        return (
          <button
            key={idx}
            type="button"
            className="rounded-sm p-0.5 outline-none transition-transform hover:scale-110 focus-visible:ring-2 focus-visible:ring-primary"
            onMouseEnter={() => setHover(idx)}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(idx)}
            aria-label={`${idx} stell${idx === 1 ? 'a' : 'e'}`}
            aria-checked={value === idx}
            role="radio"
            data-testid={testId ? `${testId}-star-${idx}` : undefined}
          >
            {StarEl}
          </button>
        );
      })}
      {showValue && value > 0 && (
        <span className="ml-1.5 text-sm font-semibold text-foreground">{Math.round(value * 10) / 10}</span>
      )}
    </div>
  );
}
